import type { IntegrationConnectionRecord } from 'types/integrations/integration-connection';
import { INTEGRATION_DEFINITIONS } from 'views/integrations/connections/integration-definitions';

/** Same key as `src/views/integrations/connections/index.tsx` — local preview storage */
export const BERRY_AI_INTEGRATIONS_LS_KEY = 'berry.integrations.center.v1';

const SUPPORTED_AI_INTEGRATION_IDS = new Set(
  INTEGRATION_DEFINITIONS.filter((d) => d.uiCategory === 'ai').map((d) => d.id),
);

/**
 * Reads integration rows saved by the Integrations center (browser localStorage).
 * Only returns AI rows that are marked connected and have a non-empty API key.
 */
export function loadConnectedAiApiKeyIntegrationsFromBrowser(): IntegrationConnectionRecord[] {
  try {
    const raw = localStorage.getItem(BERRY_AI_INTEGRATIONS_LS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return (parsed as IntegrationConnectionRecord[]).filter(
      (r) =>
        SUPPORTED_AI_INTEGRATION_IDS.has(r.id) &&
        r?.status === 'connected' &&
        r?.category === 'AI' &&
        typeof r?.config?.apiKey === 'string' &&
        r.config.apiKey.trim().length > 0,
    );
  } catch {
    return [];
  }
}
